import angular from "angular";
import Vue from "vue";
import "ngVue";

import dcLoading from "./Loading.vue";

export default angular.module("directives.loading", []).directive("dcLoading", [
  "createVueComponent",
  function (createVueComponent) {
    return createVueComponent(Vue.component("DcLoading", dcLoading));
  },
]);

